import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const NormalText = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.80048 14.2683L7.47376 7.13954L10.147 14.2683H4.80048ZM4.42548 15.2683L3.14929 18.6715C3.05233 18.93 2.76413 19.061 2.50557 18.9641C2.24701 18.8671 2.116 18.5789 2.21296 18.3203L7.0056 5.53998H7.94193L12.7346 18.3203C12.8315 18.5789 12.7005 18.8671 12.442 18.9641C12.1834 19.061 11.8952 18.93 11.7982 18.6715L10.522 15.2683H4.42548ZM17.8645 10.4757C17.1958 10.4757 16.5713 10.8099 16.2004 11.3663L15.8775 11.8506C15.7243 12.0803 15.4139 12.1424 15.1841 11.9892C14.9544 11.8361 14.8923 11.5256 15.0455 11.2959L15.3683 10.8116C15.9247 9.97696 16.8614 9.47566 17.8645 9.47566H18.8192C20.4413 9.47566 21.7628 10.7631 21.8174 12.372H21.8192C21.8192 12.3874 21.819 12.4028 21.8186 12.4182C21.819 12.4373 21.8192 12.4565 21.8192 12.4757V18.4959C21.8192 18.772 21.5953 18.9959 21.3192 18.9959C21.043 18.9959 20.8192 18.772 20.8192 18.4959V17.8473C20.0291 18.5735 18.9829 18.9959 17.8726 18.9959H17.1476C15.6462 18.9959 14.429 17.7787 14.429 16.2772C14.429 14.8633 15.5128 13.6854 16.9219 13.568L19.9509 13.3156C20.4276 13.2758 20.7974 12.8877 20.8182 12.4142C20.7857 11.3381 19.9032 10.4757 18.8192 10.4757H17.8645ZM20.8192 14.0734C20.584 14.2045 20.3182 14.2884 20.034 14.3121L17.0049 14.5645C16.1141 14.6388 15.429 15.3834 15.429 16.2772C15.429 17.2264 16.1984 17.9959 17.1476 17.9959H17.8726C19.1046 17.9959 20.2341 17.3208 20.8192 16.2435V14.0734Z"
        />
      </svg>
    )
  },
)

export default NormalText
